'use strict';

var _ = require('lodash');
var ScheduleComparisonAggregationFactory = function ScheduleComparisonAggregationFactory(DataAggregationFactory) {
  function ScheduleComparisonAggregation() {
    DataAggregationFactory.call(this, 'market-dashboard', 'dashboard-schedule');
  }
  ScheduleComparisonAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ScheduleComparisonAggregation.constructor = ScheduleComparisonAggregation;
  var config = {
    loadFactor: [{
      label: 'Flights',
      prop: 'legCount',
      average: false
    }, {
      label: 'Flight Options',
      prop: 'legOptionsCount',
      average: false
    }, {
      label: 'Capacity',
      prop: 'averagePhysicalCapacity',
      average: false
    }],
    "default": [{
      label: 'Services',
      prop: 'serviceCount',
      average: false
    }, {
      label: 'Service Options',
      prop: 'serviceOptionsCount',
      average: false
    }, {
      label: 'Elapsed Time',
      prop: 'averageElapsedTime',
      average: true
    }]
  };
  function sum(v1, v2) {
    return _.isUndefined(v2) ? v1 : (v1 || 0) + v2;
  }
  ScheduleComparisonAggregation.prototype.aggregate = function (data, metrics, metricDescriptor) {
    var aggregatedValues = {
      metrics: {}
    };
    var total = {
      referenceData: {},
      markets: {}
    };
    var scheduleConfig = config[metricDescriptor.metric] || config['default'];
    var aggregationProperties = _.map(scheduleConfig, 'prop');
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var element = data[index].scheduleChange;
      for (var propsIndex = 0, propsLength = aggregationProperties.length; propsIndex < propsLength; propsIndex++) {
        var propName = aggregationProperties[propsIndex];
        total[propName] = sum(total[propName], element[propName]);
        total.referenceData[propName] = sum(total.referenceData[propName], element.referenceData[propName]);
      }
      total.markets[data[index].market] = true;
    }
    if (Object.keys(total.markets).length !== 1) {
      return {};
    }
    _.forEach(scheduleConfig, function (configEntry) {
      var value = total[configEntry.prop];
      var refValue = total.referenceData[configEntry.prop];
      if (_.isNumber(value) && _.isNumber(refValue) && refValue !== 0) {
        aggregatedValues[configEntry.label] = (value / refValue - 1) * 100;
        aggregatedValues.metrics[configEntry.label] = {
          Curr: configEntry.average ? value / dataLength : value,
          LY: configEntry.average ? refValue / dataLength : refValue
        };
      }
    });
    return aggregatedValues;
  };
  return ScheduleComparisonAggregation;
};
ScheduleComparisonAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = ScheduleComparisonAggregationFactory;